import { AutoSaveLoadingIndicator } from '@/components/ats/collect-score-card/AutoSaveLoadingIndicator';
import { useShowToast } from '@/hooks';
import { selectCurrUser } from '@/store/bootstrap/selectors';
import { type BoxProps, Button, Flex } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { type ScorecardType } from '../../types/interview';

export const ScorecardFooter = ({
  isSaved,
  isUpdating,
  formRef,
  scorecard,
  onClear,
  scorecardFooterStyles = {},
}: {
  isSaved: boolean;
  isUpdating: boolean;
  formRef: any;
  scorecard: ScorecardType;
  onClear: () => void;
  scorecardFooterStyles?: BoxProps;
}) => {
  const toast = useShowToast();
  const currUser = useSelector(selectCurrUser);
  const { reviewer, status } = scorecard || {};
  const isCurrUserReviewer = reviewer?.id === currUser?.id;

  const buttonText = isCurrUserReviewer
    ? `${status === 'submitted' ? 'Update' : 'Submit'} scorecard`
    : `${status === 'submitted' ? 'Update' : 'Submit'} scorecard on ${
        reviewer?.name?.split(' ')[0] || 'reviewer'
      }'s behalf`;

  // const isAllMandatoryFieldsFilled =
  //   formRef.current?.values?.rating?.length > 0 &&
  //   formRef.current?.values?.feedback?.length > 0 &&
  //   scorecard?.questions?.every((item, idx) =>
  //     item?.mandatory ? formRef.current?.values?.[idx + 1] : true
  //   );

  return (
    <Flex
      justifyContent="space-between"
      gap="12px"
      w="100%"
      p="16px"
      borderTop="1px solid"
      borderColor="border-color"
      {...scorecardFooterStyles}
    >
      <AutoSaveLoadingIndicator isSaved={isSaved} />
      <Flex gap="12px">
        <Button
          variant="secondary"
          onClick={() => {
            onClear();
          }}
        >
          Clear
        </Button>
        <Button
          isLoading={isUpdating}
          loadingText="Submitting"
          onClick={() => {
            if (formRef.current) {
              const errors = formRef.current?.errors || {};
              const [key, value] = Object.entries(errors)?.[0] || [];
              if (key) {
                toast({
                  title: value,
                  status: 'error',
                });
                const element = document.getElementById(key);
                if (element) {
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  });
                }
              }
              formRef.current.handleSubmit();
            }
          }}
          // isDisabled={!isAllMandatoryFieldsFilled}
        >
          {buttonText}
        </Button>
      </Flex>
    </Flex>
  );
};
